import React from 'react';
import { Box } from '@mui/material';

/**
 * Icon component - Renders icons from the SVG sprite sheet
 *
 * @param {Object} props - Component props
 * @param {string} props.name - Name of the icon from the sprite sheet (without 'icon-' prefix)
 * @param {number|string} props.size - Size of the icon (default: 24)
 * @param {string} props.color - Color of the icon (default: inherits from currentColor)
 * @param {Object} props.sx - Additional Material-UI sx styling
 * @returns {JSX.Element} Icon component
 *
 * @example
 * // Basic usage
 * <Icon name="corner-arrow" />
 *
 * @example
 * // With custom size and color
 * <Icon name="corner-arrow" size={32} sx={{ color: 'primary.main' }} />
 *
 * @example
 * // With custom styling
 * <Icon name="corner-arrow" size={20} sx={{ color: 'error.main', cursor: 'pointer' }} />
 */
const Icon = ({
  name,
  size = 24,
  color,
  sx = {},
  ...props
}) => {
  return (
    <Box
      component="svg"
      sx={{
        width: size,
        height: size,
        display: 'inline-block',
        verticalAlign: 'middle',
        color: color || 'currentColor',
        ...sx
      }}
      {...props}
    >
      <use href={`/icons.svg?v=1.2#icon-${name}`} />
    </Box>
  );
};

export default Icon;
